export { CarView } from './CarView';
export type { CarViewProps } from './types';
